<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>景区产品列表</el-breadcrumb-item>
  
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card class="conentBox">
     
      <div class="conentRow">
          <el-input placeholder="请输入产品名称"  v-model="data.ProductName"/>
          <el-select v-model="data.ProID" clearable placeholder="请选择省份">
            <el-option
                  v-for="item in cityProvince"
                  :key="item.provinceCode"
                  :label="item.provinceName"
                  :value="item.provinceCode"
                ></el-option>
          </el-select>
          <el-select v-model="data.ScenicID" clearable  filterable placeholder="全部景区">
            <el-option
              v-for="item in scenicOption"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
          </el-select>
          <el-select v-model="data.JFYUseFlag" clearable placeholder="全部状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="ChaBtns">查询</el-button>
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="ProductName" label="产品名称"></el-table-column>
          <el-table-column prop="scenicname" label="景区名称"></el-table-column>
          <el-table-column label="景区产品状态">
            <template slot-scope="scope">
                <span>{{ scope.row.UseFlag=='0'?'上线':'下线' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="状态(请先设置代理价后再上架)">
            <template slot-scope="scope">
                <span>{{ scope.row.JFYUseFlag=='0'?'上线':'下线' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="JFYPriceDir" label="系统代理价"></el-table-column>
          <el-table-column prop="AgentPrice" label="分销商代理价"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="list"></el-pagination>
        </div>
    </el-card>
    
  </div>
</template>

<script>
import {

  getJfylistProduct
} from "@/request/worke.js";
import { scenicPost } from "@/request/scenics.js";
import cityOptions from "@/assets/city.json";

export default {
  data() {
    return {
      scenicOption:[],
      options:[
        {
          value:'0',
          label:'上线'
        },
        {
          value:'1',
          label:'下线'
        }
      ],
      cityProvince:'',
      data:{
        token:window.sessionStorage.getItem("Token"),
        ProductName:'',
        ProID:'',
        JFYUseFlag:null,
        ScenicID:'',
        page:'',
        page_size:10
      },
      tableData:[],
      total:0,
      cityProvince:'',
      product:[]
    };
  },
  created() {
    this.cityProvince = cityOptions;
    let data = {
      scenic_name: "",
        status: "",
        proid: "",
        page: 1,
        token:window.sessionStorage.getItem("Token"),
        page_size:999
    }
    scenicPost(data).then(res => {
        this.scenicOption = res.data.result.data;
      });
    this.getListItems()
  },
  methods:{
    getListItems(){
      getJfylistProduct(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    list(e){
      this.data.page = e
      this.getListItems()
    },
       
    ChaBtns(){
      this.total = 0
      this.data.page = 1
      this.getListItems()
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang="less" scoped>
.activeStatus {
  color: #ff4d4f;
}
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
    height: 266px;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}
.conentBox {
  margin-top: 20px;
  .conentDiv {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {
      display: flex;
      flex-wrap: wrap;
      .el-input {
        width: 240px;
        margin-right: 20px;
        margin-bottom: 1rem;
      }
      .el-cascader,
      .el-select {
        width: 260px;
        margin-right: 15px;
        margin-bottom: 1rem;
      }
      .el-button {
        width: 100px;
        margin-bottom: 1rem;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        border: none;
      }
    }
    > div:nth-child(2) {
      display: flex;
      justify-content: flex-end;
      .el-button {
        margin-bottom: 1rem;
        width: 120px;
        background: #ffffff;
        border: 1px solid #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #246deb;
      }
    }
  }
}
// .scenicBtn {
//   // width: 596px;
//   height: 40px;
//   display: flex;
//   justify-content: flex-end;
//   margin-left: 42px;
//   .el-button {
//     width: 120px;
//     display: flex;
//     justify-content: center;
//     font-family: ".PingFang SC";
//     font-style: normal;
//     font-weight: 400;
//     font-size: 14px;
//     // margin-right: -272px;
//     // line-height: 20px;
//     /* identical to box height */

//     color: #246deb;
//     background: #ffffff;
//     border: 1px solid #246deb;
//     border-radius: 4px;
//   }
// }

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

// 弹框
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.spanRed{
  color: red;
}

/deep/ .el-input__inner{
  color: #666666;
}
/deep/ .el-dialog__title{
   color: #000 !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}
/deep/.el-dialog__headerbtn{
  top: 0;
}
.conentBox {
  .conentRow {
    .el-input {
      width: 240px;
      margin-right: 20px;
      margin-bottom: 1rem;
    }
    .el-select {
      margin-bottom: 1rem;
      width: 260px;
      margin-right: 20px;
    }
    .el-button {
      margin-bottom: 1rem;
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
}
</style>